import React,{useRef, useState} from "react";
import Button from "src/SharedComponents/Button/Button";
import PopupDialog from "src/SharedComponents/PopupDialog/PopupDialog";
import tableStyles from 'src/Utils/CssModules/table.module.css';
import { CloseIcon } from 'src/SharedComponents/Icons/Icons';
import './AssignLicenseToClinic.css';
import SearchBar from "src/SharedComponents/SearchBar/SearchBar";
import TableHead from "src/SharedComponents/Table/TableHead";
import { useSearch } from "src/Utils/Hooks/SearchData/useSearch";
import { IClinic } from "src/Utils/Hooks/useGetDistributorInfo/useGetDistributorInfo";
import useSortableData, { SortConfig } from "src/Utils/Hooks/SortableData/useSortableData ";
import { useTranslation } from "react-i18next";

export interface IAssignLicenseToClinic{
    onClose: () => void;
    clinics: IClinic[] | undefined;
    onSubmit: (clinicId:string, clinicName: string) => void;
    entitlementId: string;
    licenseType: string;
}

const AssignLicenseToClinic:React.FC<IAssignLicenseToClinic> = ({ onClose, onSubmit, clinics, entitlementId, licenseType}) => {
    let conf: SortConfig<IClinic> = {
        key: 'name',
        direction: 'ascending'
    };

    const [searchText, setSearchText] = useState<string>('');
    const searchKeys = useRef<(keyof IClinic)[]>(['name'])
    const filteredClinics = useSearch(clinics, searchText, searchKeys.current);
    const { items, requestSort, sortConfig } = useSortableData(filteredClinics, conf);
    const {t} = useTranslation();

    return(
        <>
            <div className="assignLicenseToPartner">
                <PopupDialog onClose={() => onClose()} popupWidth="45%">
                    <div className="assign-license-header d-flex flex-column row">
                        <div className="row">
                            <div className="col-md-10">
                                <span style={{ fontWeight: 'var(--font-weight-semibold)', fontSize: 'var(--font-size-lg)' }}>{t('AssignLicense', {licenseType: licenseType, entitlementId: entitlementId})}</span>
                            </div>
                            <div className="col-md-2">
                                <i className="ds-text-primary ds-cursor-pointer" onClick={() => { onClose() }}>
                                    <CloseIcon />
                                </i>
                            </div>
                        </div>
                        <div className="row ps-4 ds-text-base ds-text-primary ds-font-regular">
                            {t('SelectAClinic')}
                        </div>
                        <div className="row mt-4">
                            <SearchBar onChange={(text:string) => {setSearchText(text) }} />
                        </div>
                    </div>
                    <div className="table-responsive" style={{overflowX:"hidden", borderRadius:'20px', marginBottom:'2px'}}>
                    <table data-testid="table" className={`table ${tableStyles.tableStriped}`}>
                            <thead className={`${tableStyles.tableHead}`}>
                                <tr key={'header'}>
                                    <TableHead<IClinic>
                                        columnName={t('ClinicName')} 
                                        paddingLeft="25px"
                                        requestSort={requestSort}
                                        sortConfig={sortConfig}
                                        columnkey="name"
                                    />
                                    <th className={tableStyles.heading}>{t('ClinicAddress')}</th>
                                    <th className={tableStyles.heading}>{ }</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items && items.map((clinic, i) => (
                                    <tr key={i}>
                                        <td className={tableStyles.data} style={{width:"40%", paddingLeft:'25px' }}>
                                            {clinic.name}
                                        </td>
                                        <td className={tableStyles.data} style={{width:"60%" }}>
                                            {clinic.address}
                                        </td>
                                        <td className={tableStyles.data} style={{ fontWeight: 600}}>
                                            <Button
                                                backgroundColor="var(--primary-color)"
                                                color="white"
                                                text={t('Assign')}
                                                borderColor="none"
                                                fontSize="12px"
                                                width='127px'
                                                onClick={() => { onSubmit(clinic.clinicId, clinic.name) }}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            
                            </tbody>
                        </table>
                    </div>
                </PopupDialog>
            </div>
        </>
    );
}

export default React.memo(AssignLicenseToClinic);